import { render } from "./KoruActionButton.vue?vue&type=template&id=6ce6d0b6&scoped=true"
import script from "./KoruActionButton.vue?vue&type=script&lang=js"
export * from "./KoruActionButton.vue?vue&type=script&lang=js"

import "./KoruActionButton.vue?vue&type=style&index=0&id=6ce6d0b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ce6d0b6"]])

export default __exports__